$(document).on('turbo:load turbo:render', () => {

    let initialVal = $("#lobbyist_registration_lobbying_year").val();
    if (initialVal && initialVal != ""){
        setDatePickerConstraints(initialVal);
    };


    $("#lobbyist_registration_lobbying_year").on("change", (e) => {
        let lobbyingYear = (<any>e).target.value;
        $(".datepicker").each(function () {
            (<any>$(this)).datepicker("clearDates");
        });
        setDatePickerConstraints(lobbyingYear);
        $(".datepicker").each(function () {
            if (this.id == "lobbyingPeriodStart"){
                let startDate =  new Date(lobbyingYear, 10, 1);
                (<any>$(this)).datepicker("update", startDate);


            }
            else if (this.id == "lobbyingPeriodEnd"){
                let endDate = new Date(parseInt(lobbyingYear) + 1, 9, 31);
                (<any>$(this)).datepicker("update", endDate );


            }
        });



        });

    $(".datepicker").each(function () {
        if (this.id == "lobbyingPeriodStart") {
            let startDateValue = (<any>$(this)).datepicker("getDate")
            if (!!startDateValue) {
                (<any>$("#lobbyingPeriodEnd")).datepicker("setStartDate", startDateValue);
            }

            (<any>$(this)).datepicker().on("changeDate", (e) => {
                (<any>$("#lobbyingPeriodEnd")).datepicker("setStartDate", e.date);

                console.log("start date changed")
            })



        } else if (this.id == "lobbyingPeriodEnd") {
            let endDateValue = (<any>$(this)).datepicker("getDate")
            if (!!endDateValue) {
                (<any>$("#lobbyingPeriodStart")).datepicker("setEndDate", endDateValue);
            }

            (<any>$(this)).datepicker().on("changeDate", (e) => {
                (<any>$("#lobbyingPeriodStart")).datepicker("setEndDate", e.date);
                console.log("end date changed")
            })
        }
    })


    $(".datepicker").each(function () {
        const lobbyingYear =  $("#lobbyist_registration_lobbying_year").val()
        if (this.id == "lobbyingPeriodStart") {
            $(this).parent().find(".datepicker-clear").on("click", ()=>{
                setDatePickerConstraints(lobbyingYear)
            })



        } else if (this.id == "lobbyingPeriodEnd") {
            $(this).parent().find(".datepicker-clear").on("click", ()=>{
                setDatePickerConstraints(lobbyingYear)
            })
        }

    })
});

function setDatePickerConstraints(lobbyingYear) {


    let startDate = new Date(lobbyingYear, 10, 1);
    let endDate = new Date(parseInt(lobbyingYear) + 1, 9, 31);
    let todayDatetime = new Date();
    let today = new Date(todayDatetime.toDateString());
    var oneDay = 24 * 60 * 60 * 1000;
    let startDateToAppend;
    if (startDate < today) {
        startDateToAppend = "-" + `${Math.round(Math.abs((startDate.getTime() - today.getTime()) / (oneDay))) }d`;
    } else {
        startDateToAppend = "+" + `${Math.round(Math.abs((startDate.getTime() - today.getTime()) / (oneDay)))  }d`;
    }
    let endDateToAppend = `${Math.round(Math.abs((endDate.getTime() - today.getTime()) / (oneDay)))  }d`;
    if (endDate < today){
        endDateToAppend = '-' + endDateToAppend
    }else{
        endDateToAppend = "+" + endDateToAppend
    }

    $(".datepicker").each(function () {


        (<any>$(this)).datepicker("setStartDate", startDateToAppend);
        (<any>$(this)).datepicker("setEndDate", endDateToAppend);


    });
}



